import { mapState } from 'vuex';
import iconsMixin from '../../core/dtwin/state/bridge/iconsMixin';
import { isEqual } from 'lodash';
const PAYLOAD = `{
    "jobName": "{{exportTitle}}",
    "date": "{{exportDate}}",
    "fileDownloadLink": "{{downloadLink}}"
}`;
export default {
  name: 'CSVForwardToThirdParty',
  mixins: [iconsMixin],
  props: {
    value: {
      type: Object,
      default: () => ({
        selectedOutboundConnector: null,
        payload: PAYLOAD
      })
    },
    readonly: {
      type: Boolean,
      default: false
    },
    outboundConnectors: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      internalModel: {
        ...this.value
      }
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    validJson() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired'), v => {
        try {
          JSON.parse(v);
          return true;
        } catch (error) {
          return this.$i18n_t('BackgroundJobs.ScheduledExports.dialog.forward.invalidJson');
        }
      }];
    },
    hasOutboundConnectors() {
      return this.outboundConnectors && this.outboundConnectors.length;
    },
    validPayload() {
      try {
        JSON.parse(this.internalModel.payload);
        return true;
      } catch (error) {
        return false;
      }
    }
  },
  watch: {
    internalModel: {
      handler() {
        this.emitInput();
      },
      deep: true
    },
    value: {
      handler(newValue) {
        if (!isEqual(newValue, this.internalModel)) {
          this.internalModel = {
            ...this.value
          };
        }
      },
      deep: true
    }
  },
  mounted() {
    if (!this.internalModel.payload) {
      this.internalModel.payload = PAYLOAD;
    }
    this.emitInput();
  },
  methods: {
    emitInput() {
      this.$emit('input', {
        ...this.internalModel,
        formIsValid: this.internalModel.selectedOutboundConnector && this.validPayload
      });
    }
  }
};